module.exports = __webpack_public_path__ + "static/media/slide2.f8e663ed.jpg";